/* eslint-disable no-param-reassign */

/* eslint-disable react/prop-types */

/* eslint-disable react/no-danger */
import React from 'react';

import { ModalComponent } from './styles';

function Modal(props) {
  return (
    <ModalComponent
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 64, 82, 0.5)',
          display: 'grid',
          gridTemplateColumns: '100vw',
          gridTemplateRows: '100vh',
          justifyItems: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(0.5rem)',
          zIndex: 50000,
        },
      }}
      {...props}
      data-test='modal'
      appElement={document.body}
    />
  );
}

export default Modal;
